<template>
  <div>
    <!-- <b-form-select
      v-if="!isCitiesLoaded"
      :options="optionsSelectState"
      :disabled="readonly"
    >
    </b-form-select> -->
    <b-form-input
      v-if="isStateEmpty"
      v-model="textSelectAnState"
      readonly="true"
    />
    <b-form-input
      v-else-if="isLoadingCities"
      v-model="textCitiesLoading"
      readonly="true"
    />
    <b-form-select
      v-else
      :options="optionsCity"
      v-model="compValue"
      :disabled="readonly"
    >
    </b-form-select>
    <!-- <div>cityId: {{ cityId }}</div> -->
  </div>
</template>

<script>
export default {
  name: "CityDropdown",
  props: {
    stateId: Number,
    cityId: Number,
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isLoadingCities: true,
      textCitiesLoading: "Carregando cidades do estado",
      textSelectAnState: "Selecione o estado",
      optionsCity: [],
      optionsSelectState: [{ value: null, text: "Selecione o estado" }],
    };
  },
  created() {
    this.loadCities();
  },
  computed: {
    compValue: {
      get: function () {
        if (this.optionsCity) {
          return this.cityId;
        }
        return null;
      },
      set: function (newValue) {
        // let selectedCity = null;
        // let selectedCityId = parseInt(newValue);
        // for (let city of this.optionsCity) {
        //   if (parseInt(city.value) == selectedCityId) {
        //     selectedCity = city;
        //     break;
        //   }
        // }
        let selectedCity = this.getCityOption(newValue);
        let selectedCityId = parseInt(newValue);
        this.$emit("update:changeData", selectedCityId);
        this.$emit("update:changeId", selectedCityId);
        if (selectedCity) {
          this.$emit("update:changeName", selectedCity.text);
        } else {
          this.$emit("update:changeName", "");
        }
      },
    },
    isStateEmpty() {
      if (!this.stateId) return true;
      if (this.stateId == null) return true;
      if (this.stateId <= 0) return true;
      return false;
    },
    getCityUrl() {
      if (this.stateId) {
        if (this.stateId > 0) {
          return `/city/getStateDropdownOptions/${this.stateId}`;
        }
      }
      return `/city/getDropdownOptions`;
    },
  },
  methods: {
    getCityOption(cityId) {
      let selectedCityId = parseInt(cityId);
      for (let city of this.optionsCity) {
        if (parseInt(city.value) == selectedCityId) {
          return city;
        }
      }
      return null;
    },
    loadCities() {
      this.isLoadingCities = true;
      if (this.stateId) {
        this.$api
          .get(this.getCityUrl)
          .then((response) => {
            this.optionsCity = response.data;
            this.isLoadingCities = false;

            let selectedCity = this.getCityOption(this.cityId);
            if (!selectedCity) this.setCityAsEmpty();
            else if (selectedCity == null) this.setCityAsEmpty();

            this.$forceUpdate();
          })
          .catch((error) => {
            this.setCityAsEmpty();
            console.log("loadCities.Error()");
            console.log(error);
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      }
    },
    setCityAsEmpty() {
      this.$emit("update:changeData", null);
      this.$emit("update:changeId", null);
      this.$emit("update:changeName", "");
    },
  },
  watch: {
    stateId(oldValue, newValue) {
      console.log(`stateId: oldValue ${oldValue} / newValue ${newValue}`);
      this.loadCities();
      // this.$emit("update:changeData", null);
      // this.$emit("update:changeId", null);
      // this.$emit("update:changeName", "");
      //   this.compValue = null;
    },
  },
};
</script>
